import {
    orderBy as _orderBy,
    sumBy as _sumBy
} from '@lodash';
import StoreUtil from '@app/store/StoreUtil';
import ITicketsState from './types';
import Ticket, { TicketService } from '@models/tickets/Ticket';

export default {
    tickets: (state: ITicketsState) => _orderBy(Object.values(state.tickets), ['dateReceived'], ['desc']),
    activeTickets: (state: ITicketsState) => {
        const active = Object.values(state.tickets).filter((ticket: Ticket) => TicketService.isActive(ticket));
        return _orderBy(active, ['dateReceived'], ['desc']);
    },
    resolvedTickets: (state: ITicketsState) => {
        const finished = Object.values(state.tickets).filter((ticket: Ticket) => TicketService.isResolved(ticket));
        return _orderBy(finished, ['dateReceived'], ['desc']);
    },
    stakeInActiveTickets: (
        state: ITicketsState,
        getters: any
    ) => _sumBy(getters.activeTickets, (ticket: Ticket) => TicketService.getStake(ticket)),
    ticketsMap: StoreUtil.createSimpleGetter('tickets'),
    getTicket: (state: ITicketsState) => (id: string) => state.tickets[id],
    isTicketSubmitting: StoreUtil.createSimpleGetter('isTicketSubmitting'),
    isTicketNegotiating: StoreUtil.createSimpleGetter('isTicketNegotiating'),
    submitErrors: StoreUtil.createSimpleGetter('submitErrors'),
    areTicketsLoading: StoreUtil.createSimpleGetter('areTicketsLoading'),
    ticketNegotiation: StoreUtil.createSimpleGetter('ticketNegotiation'),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/tickets/getters.ts